/**
 * 通讯器里去“星球活动”的那一行（放在公告细条下面；320 宽下顶上一排分段已满，同公告不加第五个分段）。
 * 不推送（CR-WORLD-OPS-PHASE2A 第 0 节）：有活动时这一行永远是同一句安静的话——不写活动标题、不数有几个、不上底色、没有红点和“新”，
 * 有几个活动、告诉没告诉过、不告诉了，这一行都一模一样；活动只在玩家自己点进去的那一页里。
 * 没有活动（列表是空的）时不显示、也不占位（用户 09-27 定：没有活动时隐藏入口，REL-02 3.11）；公告细条随之占满整行。
 * 活动列表还在读、读失败、后端还没有这条路时同样一行都不占（出错只在活动页里说，不在通讯器里打扰）。
 */
import { Link } from "react-router";
import { Icon } from "@/shared/ui";
import { usePlanetEventList } from "./usePlanetEvents";
import "./events.css";

export function PlanetEventsEntry() {
  const list = usePlanetEventList();
  if (!list.isSuccess || list.data.events.length === 0) return null;
  return (
    <Link to="/events" className="ps-events-entry" aria-label="星球活动：对大家开放的公共活动">
      <span className="ps-events-entry__tag">星球活动</span>
      <span className="ps-events-entry__text">对大家开放的公共活动</span>
      <Icon name="chevron" size={14} strokeWidth={2.2} className="ps-events-entry__go" />
    </Link>
  );
}
